import script from "./CustomerLifetimeStats.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerLifetimeStats.vue?vue&type=script&setup=true&lang=js"

import "./CustomerLifetimeStats.vue?vue&type=style&index=0&id=1e1314b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1314b4"]])

export default __exports__

/* vue-cli-plugin-import-components */

import StatTile from "@/components/customers/record/StatTile.vue";
script.components = Object.assign({}, { StatTile }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { StatTile }, script.__o.components);}